import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { rootReducer, StoreState } from "./RootReducer";

import * as Flags from "../lib/Flags";

export const RESET_ACTION_TYPE = "__RESET";

const store = Object.assign(
	(window.__store = configureStore<StoreState, any, any>({
		reducer: rootReducer,
		middleware: [
			...getDefaultMiddleware({
				immutableCheck: false,
				serializableCheck: false,
			}),
			createLogger({
				collapsed: true,
				diff: false,
				duration: true,
				predicate: () => Flags.REDUX_LOGGING.is(),
			}),
		],
		devTools: process.env.NODE_ENV !== "production",
	})),
	{
		reset: () => {
			store.dispatch({ type: RESET_ACTION_TYPE, payload: undefined });
		},
	},
);

export default store;
